<!--
 * @Author: cgh
 * @Date: 2022-07-21
 * @LastEditors: zxf
 * @LastEditTime: 2023-07-04 15:03:58
 * @Description: 问题列表
-->
<template>
  <el-dialog
    v-loading="loading"
    class="o-dialog o-no-modal-bg o-dialog--sm o-dialog--md-70 o-dialog--lg-60 o-dialog--xl-50"
    title="问题详情"
    :visible.sync="dialogShow"
    :modal="false"
    :close-on-click-modal="false"
    @close="closeDialog()"
  >
    <section>
      <el-form
        ref="fd"
        class="c-form"
        :model="fd"
        :inline="true"
        label-position="right"
        label-width="150px"
        label-suffix="："
      >
        <el-row
          class="c-form__row"
        >
          <el-col
            class="c-form__col"
            :span="24"
          >
            <el-form-item
              class="c-form__item"
              label="项目名称"
              prop="xmMc"
            >
              <span
                class="c-form__read"
              >
                {{ fd.xmMc }}
              </span>
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="24"
          >
            <el-form-item
              class="c-form__item"
              label="安全类别"
              prop="aqlbMc"
            >
              <span
                class="c-form__read"
              >
                {{ fd.fxzbMc }} {{ fd.dxzbMc }}
              </span>
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="12"
          >
            <el-form-item
              class="c-form__item"
              label="具体位置"
              prop="szwz"
            >
              <span
                class="c-form__read"
              >
                {{ fd.szwz }}
              </span>
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="12"
          >
            <el-form-item
              class="c-form__item"
              label="不符合检查项个数"
              prop="bfhgs"
            >
              <span
                class="c-form__read"
              >
                {{ fd.bfhgs }}
              </span>
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="12"
          >
            <el-form-item
              class="c-form__item"
              label="风险类别"
              prop="fxcd"
            >
              <span
                class="c-form__read"
              >
                {{ fd.fxcd === 'h' ?'高':fd.fxcd === 'm' ? '中' :'低' }}
              </span>
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="12"
          >
            <el-form-item
              class="c-form__item"
              label="重大火灾隐患"
              prop="zdhzyh"
            >
              <span
                class="c-form__read"
              >
                {{ fd.zdhzyh === 'Y' ? '是' : '否' }}
              </span>
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="24"
          >
            <el-form-item
              class="c-form__item"
              label="问题描述"
              prop="wtxq"
            >
              <span
                class="c-form__read"
              >
                {{ fd.wtxq }}
              </span>
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="24"
          >
            <el-form-item
              class="c-form__item"
              label="对策和措施"
              prop="dccs"
            >
              <span
                class="c-form__read"
              >
                {{ fd.dccs }}
              </span>
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="24"
          >
            <el-form-item
              class="c-form__item"
              label="检验依据"
              prop="jcyj"
            >
              <span
                class="c-form__read"
              >
                {{ fd.jcyj }}
              </span>
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="24"
          >
            <el-form-item
              class="c-form__item"
              label="可能产生的后果"
              prop="fxms"
            >
              <span
                class="c-form__read"
              >
                {{ fd.fxms }}
              </span>
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="24"
          >
            <el-form-item
              class="c-form__item"
              label="具体照片"
              prop="fjIdList"
            >
              <!-- <div class="o-pgwt">
                <el-image
                  v-for="(item,index) in fd.xgfj"
                  :key="index"
                  :preview-src-list="fd.xgfj"
                  class="o-pgwt__img"
                  :src="item"
                />
              </div> -->

              <image-upload-list
                v-model="fd.fjIdList"
                multiple
                disabled
                list-type="picture-card"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </section>
    <div
      slot="footer"
      class="o-dialog__footer"
    >
      <k-button
        btn-text="关闭"
        :auth-type="false"
        @click="closeDialog()"
      />
    </div>
  </el-dialog>
</template>

<script>
import { wtlbManageService } from './wtlb.service.js';
export default {
  name: 'DetailsDialog',
  props: {
    dlParams: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data () {
    return {
      dialogShow: true, // 模态框dialog显示

      loading: false, // 页面是否加载
      /* 表单参数 Start */
      fd: {
        id: null,
        aqlbMc: null, // 安全类别
        xmMc: null, // 客户名称
        szwz: null, // 具体位置
        bfhgs: null, // 问题数量
        fxcd: null, // 风险类别
        zdhzyh: null, // 重大火灾隐患
        wtxq: null, // 问题描述
        dccs: null, // 对策和措施
        jcyj: null, // 检验依据
        fxms: null, // 可能产生的后果
        xgfj: [] // 相关附件
      }
      /* 表单参数 End */

    };
  },
  methods: {
    /**
     * @description: 关闭模态框dialog
     * @param {*}
     * @return {*}
     */
    closeDialog () {
      this.$emit('closeDialog', '');
    },
    /**
     * 初始化数据
     */
    init (_id) {
      // this.loading = true;
      wtlbManageService.getDetail(_id)
        .then(rsp => {
          this.fd = Object.assign({}, this.fd, rsp.data);
        })
        .catch(err => {
          console.error('获取评估仪器信息错误！', err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    winOpen (fileUrl) {
      window.open(fileUrl);
    }

  },
  created () {
    this.init(this.dlParams.id);
  }
};

</script>

<style lang="scss">
.o-pgwt {
  display: flex;
  align-content: stretch;
}

.o-pgwt__img {
  width: 100px;
  height: 100px;
  object-fit: cover;
  cursor: pointer;

  & + .o-pgwt__img{
    margin-left: 10px;
  }
}
</style>
